export default __webpack_public_path__ + "static/media/quick-access-transactions-image.6ca6ac82.jpg";